import React,{useEffect,useRef} from 'react';
import emailjs from '@emailjs/browser';
import '../auth/auth.css';
import { useNavigate } from 'react-router-dom';
import './contact.css';

const Contact = () => {
  const navigate=useNavigate();
  useEffect(() => {
    // setwidth(window.innerWidth);
    document.title = "Contact us | Daily Blogs"
}, []);
const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_so8yjoa', 'template_nohv837', form.current, 'EBHJ2z_9_SVD6BAuP')
      .then((result) => {
          if(result.text==="OK"){
            window.alert("Thanks for contacting us 😊. Your response has been submitted.");
            navigate('/');
          }
      }, (error) => {
          console.log(error.text);
      });
    }
    return (
      <div className="contact-container">
      <form ref={form} onSubmit={sendEmail}>
        <h1>Contact Us</h1>
      <div className="input-element">
      <label>Name</label><br />
      <input type="text" name="user_name" placeholder='Enter Your Name...' required/><br />
      </div>
      <div className="input-element">
      <label>Email</label><br />
      <input type="email" name="user_email" placeholder='Enter Your Email...' required/><br />
      </div>
      <div className="input-element">
      <label>Message</label><br />
      <textarea name="message" placeholder='Type Message...' rows={6} required/><br />
      </div>
      <div className="input-elemnt">
        <input type="submit" value="Send" />
      </div>
    </form>
    </div>
    );
}

export default Contact;
